<div class="text-center" *ngIf="rowData.isActive; else archived">
	<div class="text-center  badge-success">
		{{ 'ORGANIZATIONS_PAGE.ACTIVE' | translate }}
	</div>
</div>
<ng-template #archived>
	<div class="text-center">
		<div class="badge-danger d-block">
			{{ 'ORGANIZATIONS_PAGE.ARCHIVED' | translate }}
		</div>
	</div>
</ng-template>
